export const mobileHeroLeadText = `
  @media (max-width: 600px) {
    font-size: 15px;
    line-height: 1.55;
  }
`;

export const mobileLeadText = `
  @media (max-width: 600px) {
    font-size: 15px;
    line-height: 1.55;
  }
`;
